export default __webpack_public_path__ + "static/media/grid2.d1457288.png";